import { Button, Group, Loader, Modal, Stack, Text } from '@common/ui'
import React from 'react'
import { com } from '@eidu/web'
import EntityLabelLines from '../data/EntityLabelLines'
import EntityWithLabelAndRelated from '../../domain/entity/EntityWithLabelAndRelated'
import EntityId = com.eidu.entity.EntityId

export type AddExistingToSetModalProps = {
  opened: boolean
  onClose: () => void
  title: string
  candidates: readonly EntityWithLabelAndRelated[]
  isMember: (id: EntityId) => boolean
  onAdd: (id: EntityId) => void
  busy?: boolean
  loading?: boolean
  hasMore?: boolean
  loadMore?: () => void
}

const AddExistingToSetModal = ({
  opened,
  onClose,
  title,
  candidates,
  isMember,
  onAdd,
  busy = false,
  loading = false,
  hasMore = false,
  loadMore,
}: AddExistingToSetModalProps) => (
  <Modal opened={opened} onClose={onClose} title={title} size="md">
    <Stack gap="md">
      <div style={{ maxHeight: 360, overflowY: 'auto' }}>
        {candidates.length === 0 ? (
          <Group justify="center" py="md">
            {loading ? <Loader size="sm" /> : <Text c="dimmed">Nothing to add</Text>}
          </Group>
        ) : (
          candidates.map((candidate) => {
            const added = isMember(candidate.entity.id)
            return (
              <Group
                key={candidate.entity.id.toString()}
                data-testid="reference-set-candidate"
                justify="space-between"
                align="center"
                wrap="nowrap"
                py="sm"
                style={{ borderBottom: '1px solid #eee' }}
              >
                <EntityLabelLines primary={candidate.primaryLabelText} secondary={candidate.secondaryLabelText} />
                {added ? (
                  <Text size="sm" c="dimmed" style={{ flexShrink: 0 }}>
                    Added
                  </Text>
                ) : (
                  <Button
                    size="xs"
                    variant="light"
                    onClick={() => onAdd(candidate.entity.id)}
                    disabled={busy}
                    style={{ flexShrink: 0 }}
                  >
                    Add
                  </Button>
                )}
              </Group>
            )
          })
        )}
        {hasMore && (
          <Group justify="center" py="sm">
            <Button size="xs" variant="subtle" onClick={loadMore} loading={loading}>
              Load more
            </Button>
          </Group>
        )}
      </div>
      <Text size="sm" c="dimmed">
        Each result adds immediately — there&apos;s no separate save step, since every add is its own operation.
      </Text>
      <Group justify="flex-end">
        <Button onClick={onClose}>Done</Button>
      </Group>
    </Stack>
  </Modal>
)

export default AddExistingToSetModal
